import { Component, OnInit } from '@angular/core';
import { CutOffTimes } from '@approot/models';
import { ConfigService, TradeStatus } from '@approot/services';
import { clone } from '@approot/utilities';
import { Debounce } from 'lodash-decorators';
import { DisplayDefinitionsService } from '../display-definitions.service';

@Component({
  selector: 'app-trade-status',
  templateUrl: './trade-status.component.html',
  styleUrls: ['./trade-status.component.scss']
})
export class TradeStatusComponent implements OnInit {
  public sources: CutOffTimes[];
  public statuses: TradeStatus;
  public filteredStatuses: TradeStatus;
  public search: string;

  constructor(
    private svc: DisplayDefinitionsService,
    private configService: ConfigService
  ) {}

  public ngOnInit() {
    this.configService
      .getCutOffTimes()
      .subscribe(cutoffs => (this.sources = cutoffs));

    this.configService.getAllowedTradeStatuses().subscribe(statuses => {
      this.statuses = clone(statuses, true);
      this.filteredStatuses = clone(statuses);
    });
  }

  public get modalOpen(): boolean {
    return this.svc.showTradeStatus;
  }

  public modalChanged(event: boolean) {
    this.svc.showTradeStatus = event;
  }

  @Debounce(150)
  public searchChanged(search: string) {
    search = search.toLowerCase();
    this.filteredStatuses.allowed_statuses =
      this.statuses.allowed_statuses.filter(s =>
        s.longName.toLowerCase().includes(search)
      );
  }
}
